(function(){
"use strict";

const fmt = n => "$" + n.toLocaleString("es-CL");
// Precios copiados de Kaching el 16-10 (en la versión final salen de Kaching o de metacampos)
const PACKS = [
  {id:"p1", name:"1 Caja", short:"1 Caja", caps:60, perCap:417, price:24990, was:null, free:false},
  {id:"p3", name:"3 Cajas", short:"3 Cajas", caps:180, perCap:305, price:54979, was:74970, free:true, tag:"Más vendido"},
  {id:"p6", name:"6 Cajas", short:"6 Cajas", caps:360, perCap:272, price:97899, was:149940, free:true, tag:null}
];
const pk = id => PACKS.find(x => x.id === id);
const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
const buyEl = () => document.querySelector("kaching-bundle") || document.querySelector(".product-form") || document.querySelector(".product__info-container");
const go = () => { const b = buyEl(); if (b) b.scrollIntoView({behavior: reduce ? "auto" : "smooth", block: "center"}); };
function pickK(id){
  const i = {p1:0, p3:1, p6:2}[id];
  const bars = [...document.querySelectorAll("kaching-bundle .kaching-bundles__bar")].filter(b => !b.classList.contains("kaching-bundles__checkbox-upsells__upsell"));
  if (bars[i]) bars[i].click();
  go();
}
function render(){
  document.querySelectorAll("[data-strip]").forEach(el => {
    el.innerHTML = PACKS.map(p => `<button class="spt" role="radio" aria-checked="false" data-id="${p.id}">
      ${p.tag ? `<span class="tg">${p.tag}</span>` : ""}
      <b>${p.name}</b><span class="pr num">${fmt(p.price)}</span><span class="pd num">${fmt(p.perCap)} la cápsula</span>
      <span class="sh">${p.free ? "Despacho gratis" : "Despacho aparte"}</span></button>`).join("");
  });
  const sr = document.getElementById("sRows");
  if (sr) sr.innerHTML = [pk("p3"), pk("p6")].map(r => `<span class="s-row ${r.id==="p3" ? "hi" : ""}"><span class="n">${r.short}</span><b class="num">${fmt(r.perCap)}/cápsula</b><span class="num">${fmt(r.price)}</span></span>`).join("");
}
document.addEventListener("click", e => {
  const sb = e.target.closest(".lp .spt"); if (sb) { pickK(sb.dataset.id); return; }
  const dp = e.target.closest(".lp [data-pick]"); if (dp) { pickK(dp.dataset.pick); return; }
  if (e.target.closest("#sBtn")) go();
});
render();
// Despacho según la hora de Santiago
function despacho(){
  let h = 12;
  try { h = +new Intl.DateTimeFormat("es-CL", {timeZone:"America/Santiago", hour:"numeric", hourCycle:"h23"}).format(new Date()); } catch(e) {}
  const DIAS = ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"];
  let d = new Date();
  try { const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", {timeZone:"America/Santiago", year:"numeric", month:"numeric", day:"numeric"}).formatToParts(d).map(x => [x.type, x.value])); d = new Date(+p.year, +p.month - 1, +p.day); } catch(e) {}
  // Feriados irrenunciables (Ley 19.973): ese día no hay despacho, pasa al día siguiente
  const FER = ["2026-01-01","2026-05-01","2026-09-18","2026-09-19","2026-12-25","2027-01-01","2027-05-01","2027-09-18","2027-09-19","2027-12-25"];
  const ymd = x => x.getFullYear() + "-" + String(x.getMonth() + 1).padStart(2, "0") + "-" + String(x.getDate()).padStart(2, "0");
  let k = h >= 12 ? 1 : 0;
  d.setDate(d.getDate() + k);
  while (FER.includes(ymd(d))) { d.setDate(d.getDate() + 1); k++; }
  const txt = `Llega ${k === 0 ? "hoy" : k === 1 ? "mañana" : "el"} ${DIAS[d.getDay()]} ${d.getDate()} (RM)`;
  document.querySelectorAll("[data-ship]").forEach(el => el.textContent = txt);
}
despacho(); setInterval(despacho, 60000);

// Resultados: el detalle se abre bajo la fila del ícono tocado
const IC = {
  bloat:'<circle cx="12" cy="12" r="8.5" fill="none" stroke="#1A1B18" stroke-width="2"/><path d="M8 12h8" stroke="#1A1B18" stroke-width="2" stroke-linecap="round"/>',
  clock:'<circle cx="12" cy="12" r="8.5" fill="none" stroke="#1A1B18" stroke-width="2"/><path d="M12 7v5l3.5 2" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
  pill:'<rect x="3.5" y="8.5" width="17" height="7" rx="3.5" fill="none" stroke="#1A1B18" stroke-width="2" transform="rotate(-35 12 12)"/><path d="M9.6 8.6l4.8 6.8" stroke="#1A1B18" stroke-width="2"/>',
  gut:'<path d="M7 4v4c0 2 2 3 5 3s5 1 5 3-2 3-5 3-5 1-5 3" fill="none" stroke="#1A1B18" stroke-width="2" stroke-linecap="round"/>'
};
const OUT = [
  {ic:"bloat", area:"Hinchazón", pain:"Después de comer.", win:"Un estómago más liviano", body:"Cada cápsula trae 25 mil millones de UFC de bacterias que fermentan lo que comes y producen ácido láctico. Tomándolo todos los días, la digestión se siente más liviana y con menos hinchazón.", d:[["UFC por cápsula","25 mil millones"],["Cepas","5"]]},
  {ic:"clock", area:"Regularidad", pain:"En el baño, cada día.", win:"Tu ritmo, de vuelta", body:"Las bifidobacterias (B. lactis WKB148 y B. infantis BI45) habitan el intestino grueso, donde se juega la regularidad. Con el plan diario, el tránsito se vuelve más regular.", d:[["Bifidobacterias","2 cepas"],["De cada una","5 mil millones"]], q:["Me gustó mucho este probiótico. Había probado otros antes y me ponían algo estítica, pero este me resultó muy bueno, voy todos los días al baño, menos hinchazón y deposición más blanda. Gracias por preguntar. Lo recomiendo 👍.","Patricia G.S."]},
  {ic:"pill", area:"Refuerzo", pain:"Cuando tu rutina cambia.", win:"Apoyo cuando más lo necesitas", body:"Viajes, estrés, cambios de dieta o antibióticos, que también arrasan con bacterias buenas. En esos días, el plan dice volver a 2 cápsulas: 50 mil millones de UFC, 5 mil millones de cada cepa, para acompañar a tu microbiota durante y después.", d:[["Refuerzo","2 cápsulas"],["UFC","50 mil millones"]], q:["Recuperación de microbiota tras antibióticos 🔥","Anónimo"]},
  {ic:"gut", area:"Todo el intestino", pain:"Del intestino delgado al grueso.", win:"Apoyo de punta a punta", body:"Tres lactobacilos (L. rhamnosus LRa66, L. acidophilus LA18 y L. casei LC89), que viven sobre todo en el intestino delgado, y dos bifidobacterias en el grueso. Cada una con 5 mil millones de UFC: ninguna de adorno.", d:[["Lactobacilos","3 cepas"],["Bifidobacterias","2 cepas"]]}
];
let oi = 0;
const og = document.getElementById("og");
const wide = matchMedia("(min-width: 720px)");
function renderOut(){
  if (!og) return;
  const tiles = OUT.map((o,i) => `<button class="ot" aria-expanded="${i===oi}" aria-controls="od" data-i="${i}">
      <span class="top"><span class="ic"><svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">${IC[o.ic]}</svg></span><span class="chev" aria-hidden="true">▾</span></span>
      <b>${o.area}</b><span class="p">${o.pain}</span></button>`);
  tiles.push(`<button class="ot cta" data-pick="p3"><b>Todo esto en una cápsula</b><span class="p">Desde $272 la cápsula →</span></button>`);
  let html = "";
  const per = wide.matches ? 4 : 2;
  for (let r = 0; r < tiles.length; r += per) {
    html += tiles.slice(r, r + per).join("");
    if (oi >= 0 && Math.floor(oi/per) === r/per) {
      const o = OUT[oi];
      html += `<div class="od" id="od" role="region" aria-label="${o.area}"><p class="label">${o.area}</p><p class="win">${o.win}</p><p>${o.body}</p><div class="doses">${o.d.map(x=>`<span class="dose">${x[0]} <b>${x[1]}</b></span>`).join("")}</div>${o.q ? `<q>"${o.q[0]}"<cite>${o.q[1]} <span class="cv">✓ Compra verificada</span></cite></q>` : ""}</div>`;
    }
  }
  og.innerHTML = html;
}
if (og) og.addEventListener("click", e => {
  const b = e.target.closest(".ot:not(.cta)"); if (!b) return;
  const i = +b.dataset.i; oi = (oi === i) ? -1 : i; renderOut();
  og.querySelector(`[data-i="${i}"]`).focus();
});
renderOut();
wide.addEventListener("change", renderOut);

// Etiqueta
const lm = document.getElementById("labelModal"); let lastFocus = null;
if (lm) {
  document.querySelectorAll("[data-label]").forEach(b => b.addEventListener("click", () => { lastFocus = b; lm.hidden = false; document.getElementById("labelClose").focus(); }));
  const closeLm = () => { lm.hidden = true; if (lastFocus) lastFocus.focus(); };
  document.getElementById("labelClose").addEventListener("click", closeLm);
  lm.addEventListener("click", e => { if (e.target === lm) closeLm(); });
  document.addEventListener("keydown", e => { if (e.key === "Escape" && !lm.hidden) closeLm(); });
}
if (reduce) document.querySelectorAll(".lp video").forEach(v => { v.removeAttribute("autoplay"); v.pause(); });

// Barra fija: aparece solo cuando no hay otra compra a la vista (sin ruido de botones)
(function(){
  const bar = document.querySelector(".lp .sticky"); if (!bar) return;
  const zones = () => [document.querySelector(".product__info-container"), document.querySelector(".lp-galeria"), ...document.querySelectorAll(".lp .strip"), document.querySelector(".lp .final")].filter(Boolean);
  const update = () => {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const hide = zones().some(z => { const r = z.getBoundingClientRect(); return r.bottom > 0 && r.top < vh - 40; });
    bar.classList.toggle("is-hidden", hide); bar.toggleAttribute("inert", hide);
  };
  addEventListener("scroll", update, {passive: true}); addEventListener("resize", update);
  update();
})();

// Galería propia: se mueve a la columna de fotos del theme y se arma el carrusel
(function(){
  const g = document.querySelector(".lp-galeria"), mw = document.querySelector(".product__media-wrapper");
  if (g && mw) { mw.prepend(g); document.documentElement.classList.add("lp-gal-ok"); }
  const tr = document.getElementById("track"); if (!tr) return;
  const slides = [...tr.children], n = slides.length;
  const dots = document.getElementById("dots"), th = document.getElementById("thumbs"), cnt = document.getElementById("gcount");
  dots.innerHTML = slides.map((s, i) => `<button class="dot" data-go-slide="${i}" aria-label="Ir a: ${s.dataset.name}"></button>`).join("");
  th.innerHTML = "";
  slides.forEach((s, i) => {
    const b = document.createElement("button"); b.className = "th"; b.dataset.goSlide = i; b.setAttribute("aria-label", "Ir a: " + s.dataset.name);
    const c = s.cloneNode(true); c.setAttribute("aria-hidden", "true"); c.removeAttribute("data-name");
    c.querySelectorAll("video").forEach(v => { const im = document.createElement("img"); im.className = "vposter"; im.src = (s.querySelector("video") || {}).poster || ""; im.alt = ""; v.replaceWith(im); });
    c.querySelectorAll("button,[data-label]").forEach(x => { x.removeAttribute("data-label"); x.setAttribute("tabindex", "-1"); });
    b.appendChild(c); th.appendChild(b);
  });
  const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : tr.clientWidth);
  const idx = () => Math.round(tr.scrollLeft / step());
  const mark = () => { const k = idx(); cnt.textContent = (k + 1) + " / " + n; document.querySelectorAll("[data-go-slide]").forEach(b => b.setAttribute("aria-current", +b.dataset.goSlide === k ? "true" : "false")); };
  const goS = k => { k = (k + n) % n; tr.scrollTo({left: k * step()}); };
  tr.addEventListener("scroll", mark, {passive:true});
  tr.addEventListener("keydown", e => { if (e.key === "ArrowRight") goS(idx() + 1); if (e.key === "ArrowLeft") goS(idx() - 1); });
  document.addEventListener("click", e => {
    const d = e.target.closest("[data-go-slide]"); if (d) { goS(+d.dataset.goSlide); return; }
    const g2 = e.target.closest("[data-gnav]"); if (g2) goS(idx() + +g2.dataset.gnav);
  });
  mark();
})();

})();
